<form [formGroup]="formGroup"
      class="checkbox"
      *transloco="let t">
  <div class="checkbox-label">
    <mat-checkbox color="primary"
                  [formGroup]="formGroup"
                  [formControlName]="abstractFormControlName"
                  [ngClass]="{error: control.dirty && control.invalid}">
    </mat-checkbox>
    <app-label [isGray]="!anchorTermsLink || !anchorPrivacyLink">
      <ng-content *ngIf="!anchorTermsLink && !anchorPrivacyLink"></ng-content>
      <ng-container *ngIf="anchorTermsLink && anchorPrivacyLink">
        {{ label }}
        <app-anchor target="_blank" [href]="anchorTermsLink">
          {{ anchorTermsText }}
        </app-anchor> |
        <app-anchor target="_blank" [href]="anchorPrivacyLink">
          {{ anchorPrivacyText }}
        </app-anchor>
      </ng-container>
    </app-label>
  </div>
  <div class="break"></div>
  <mat-error *ngIf="control.dirty && control.invalid">
    {{ t(requiredErrorText) }}
  </mat-error>
</form>
